import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlMpFieldsFragment = { id: string, initials?: string | null, chairman: boolean, secretary: boolean, adjuster: boolean, present: boolean, summoned?: boolean | null, position?: string | null, isShareholder: boolean, kind: Types.GqlMpKind, proxyId?: string | null, meetingId?: string | null, identityId: string, createdAt: string, updatedAt: string };

export const MpFieldsFragmentDoc = gql`
    fragment MpFields on MeetingParticipant {
  id
  initials
  chairman
  secretary
  adjuster
  present
  summoned
  position
  isShareholder
  kind
  proxyId
  meetingId
  identityId
  createdAt
  updatedAt
}
    `;